import { useParams, Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { POLICIES } from "@/lib/policies";

export default function Legal() {
  const { slug } = useParams();
  const page = POLICIES[slug] || POLICIES.about;
  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid={`legal-page-${slug}`}>
        <Link to="/" className="text-sm text-primary" data-testid="legal-back-link">← Back</Link>
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight mt-4 mb-3">{page.title}</h1>
        {page.version && <p className="text-xs text-muted-foreground mb-10" data-testid="legal-version">Version {page.version}</p>}
        <div className="space-y-5 text-muted-foreground leading-relaxed mt-8">
          {page.body.map((p) => <p key={p.slice(0, 40)}>{p}</p>)}
        </div>
      </main>
      <Footer />
    </div>
  );
}
